import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomNotifyMeComponent} from './custom-notify-me.component';
import {AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {CustomStockNotificationModule} from '../../product/custom-stock-notification/custom-stock-notification.module';
import {RouterModule} from '@angular/router';
import {CustomAddToWishListModule} from '../../cart/custom-add-to-whish-list/custom-add-to-wish-list.module';
import {
  MediaModule,
  PaginationModule,
  SpinnerModule,
  StarRatingModule,
  StockNotificationModule
} from '@spartacus/storefront';
import {CustomIconsModule} from '../../../../../custom/icons/custom-icons.module';
import {CustomPipesModule} from "../../../../../custom/pipes/custom-pipes";


@NgModule({
  declarations: [CustomNotifyMeComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountNotificationsHistoryComponent: {
          component: CustomNotifyMeComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
    CustomStockNotificationModule,
    RouterModule,
    CustomAddToWishListModule,
    MediaModule,
    I18nModule,
    UrlModule,
    StockNotificationModule,
    StarRatingModule,
    CustomIconsModule,
    PaginationModule,
    CustomPipesModule,
    SpinnerModule,
  ]
})
export class CustomNotifyMeModule {
}


